import { usePubSub } from "@videosdk.live/react-sdk";
import { useAppContext } from "../AppContextDef";

const PubSubHandler = () => {
  const {
    setAllPubsubData,
    setCurrentPageData,
    setFaceVerified,
    setAgreedData,
    setFaceDetectError,
    setMediaPermissionError,
    setIsAgreeButtonClick,
    setIsDisagreeButtonClick,
    setIsTimerRunningData,
    setJourneyConfigData,
    setJourneyPubsubData,
    setTimerData,
    setRunningTimeData,
    setSelectedLang,
    setIsVideoConsentStart,
    setOpenVideoErr,
    setOpenVideoFailErr,
    setIsAbortSignal,
    setIsJourneyEnded,
    setOpenDeviceChange,
    setOpenErrorBox,
    setOpenTextMatchErr,
    setAccuracy,
    setOpenJourneyLimitBox
  } = useAppContext();

  usePubSub("CURRENT_PAGE", {
    onMessageReceived: ({ payload }) => {
      setCurrentPageData(payload?.message);
      // if (handlePageDataFromChild) {
      //   handlePageDataFromChild(message?.message);
      // }
      setFaceVerified(false);
    },
    onOldMessagesReceived: (messages) => {
      const latestMessage = messages.sort((a, b) => {
        if (a.timestamp > b.timestamp) {
          return -1;
        }
        if (a.timestamp < b.timestamp) {
          return 1;
        }
        return 0;
      })[0];

      if (latestMessage) {
        setCurrentPageData(latestMessage.payload?.message);
      }
    },
  });

  usePubSub("SELECT_LANG", {
    onMessageReceived: ({ message }) => {
      setSelectedLang({ lang: message, timestamp: Date.now() });
    },
    onOldMessagesReceived: (messages) => {
      const latestMessage = messages.sort((a, b) => {
        if (a.timestamp > b.timestamp) {
          return -1;
        }
        if (a.timestamp < b.timestamp) {
          return 1;
        }
        return 0;
      })[0];

      if (latestMessage) {
        setSelectedLang({ lang: latestMessage.message, timestamp: Date.now() });
      }
    },
  });

  usePubSub("ALL_DETAILS", {
    onMessageReceived: ({ payload }) => {
      setAllPubsubData(payload.message);
    },
    onOldMessagesReceived: (messages) => {
      const latestMessage = messages.sort((a, b) => {
        if (a.timestamp > b.timestamp) {
          return -1;
        }
        if (a.timestamp < b.timestamp) {
          return 1;
        }
        return 0;
      })[0];

      if (latestMessage) {
        setAllPubsubData(latestMessage.payload?.message);
      }
    },
  });

  usePubSub("JOURNEY_CONFIG_DATA", {
    onMessageReceived: ({ payload }) => {
      setJourneyConfigData(payload);
    },
    onOldMessagesReceived: (messages) => {
      const latestMessage = messages.sort((a, b) => {
        if (a.timestamp > b.timestamp) {
          return -1;
        }
        if (a.timestamp < b.timestamp) {
          return 1;
        }
        return 0;
      })[0];

      if (latestMessage) {
        setJourneyConfigData(latestMessage.payload);
      }
    },
  });

  usePubSub("JOURNEY_DATA", {
    onMessageReceived: ({ payload }) => {
      setJourneyPubsubData(payload);
    },
    onOldMessagesReceived: (messages) => {
      const latestMessage = messages.sort((a, b) => {
        if (a.timestamp > b.timestamp) {
          return -1;
        }
        if (a.timestamp < b.timestamp) {
          return 1;
        }
        return 0;
      })[0];

      if (latestMessage) {
        setJourneyPubsubData(latestMessage.payload);
      }
    },
  });

  usePubSub("MEDIA_ERROR", {
    onMessageReceived: ({ payload }) => {
      setMediaPermissionError(payload.err);
    },
    onOldMessagesReceived: (messages) => {
      const latestMessage = messages.sort((a, b) => {
        if (a.timestamp > b.timestamp) {
          return -1;
        }
        if (a.timestamp < b.timestamp) {
          return 1;
        }
        return 0;
      })[0];

      if (latestMessage) {
        setMediaPermissionError(latestMessage.payload.err);
      }
    },
  });

  usePubSub("FACE_DETECT_ERROR", {
    onMessageReceived: ({ payload }) => {
      setFaceDetectError({ err: payload.err, timestamp: Date.now() });
    },
    onOldMessagesReceived: (messages) => {
      const latestMessage = messages.sort((a, b) => {
        if (a.timestamp > b.timestamp) {
          return -1;
        }
        if (a.timestamp < b.timestamp) {
          return 1;
        }
        return 0;
      })[0];

      if (latestMessage) {
        setFaceDetectError({
          err: latestMessage.payload.err,
          timestamp: Date.now(),
        });
      }
    },
  });

  usePubSub("FACE_VERIFIED", {
    onMessageReceived: ({ payload }) => {
      setFaceVerified({
        isVerified: payload.isVerified,
        timestamp: Date.now(),
      });
    },
    onOldMessagesReceived: (messages) => {
      const latestMessage = messages.sort((a, b) => {
        if (a.timestamp > b.timestamp) {
          return -1;
        }
        if (a.timestamp < b.timestamp) {
          return 1;
        }
        return 0;
      })[0];

      if (latestMessage) {
        setFaceVerified({
          isVerified: latestMessage.payload.isVerified,
          timestamp: Date.now(),
        });
      }
    },
  });

  usePubSub("AGREED", {
    onMessageReceived: ({ payload }) => {
      setAgreedData(payload.isAgreed);
    },
    onOldMessagesReceived: (messages) => {
      const latestMessage = messages.sort((a, b) => {
        if (a.timestamp > b.timestamp) {
          return -1;
        }
        if (a.timestamp < b.timestamp) {
          return 1;
        }
        return 0;
      })[0];

      if (latestMessage) {
        setAgreedData(latestMessage.payload.isAgreed);
      }
    },
  });

  usePubSub("START_VIDEO", {
    onMessageReceived: ({ payload }) => {
      setIsVideoConsentStart(payload.isStart);
    },
    onOldMessagesReceived: (messages) => {
      const latestMessage = messages.sort((a, b) => {
        if (a.timestamp > b.timestamp) {
          return -1;
        }
        if (a.timestamp < b.timestamp) {
          return 1;
        }
        return 0;
      })[0];

      if (latestMessage) {
        setIsVideoConsentStart(latestMessage.payload.isStart);
      }
    },
  });

  usePubSub("AGREE", {
    onMessageReceived: ({ payload }) => {
      setIsAgreeButtonClick({
        isAgreeClick: payload.isAgreeClick,
        currentPage: payload.currentPage,
      });
    },
    onOldMessagesReceived: (messages) => {
      const latestMessage = messages.sort((a, b) => {
        if (a.timestamp > b.timestamp) {
          return -1;
        }
        if (a.timestamp < b.timestamp) {
          return 1;
        }
        return 0;
      })[0];

      if (latestMessage) {
        setIsAgreeButtonClick({
          isAgreeClick: latestMessage.payload.isAgreeClick,
          currentPage: latestMessage.payload.currentPage,
        });
      }
    },
  });

  usePubSub("DISAGREE", {
    onMessageReceived: ({ payload }) => {
      setIsDisagreeButtonClick({
        isDisagreeClick: payload.isDisagreeClick,
        currentPage: payload.currentPage,
      });
    },
    onOldMessagesReceived: (messages) => {
      const latestMessage = messages.sort((a, b) => {
        if (a.timestamp > b.timestamp) {
          return -1;
        }
        if (a.timestamp < b.timestamp) {
          return 1;
        }
        return 0;
      })[0];

      if (latestMessage) {
        setIsDisagreeButtonClick({
          isDisagreeClick: latestMessage.payload.isDisagreeClick,
          currentPage: latestMessage.payload.currentPage,
        });
      }
    },
  });

  usePubSub("TIMER_RUNNING", {
    onMessageReceived: ({ payload }) => {
      setIsTimerRunningData({
        isRunning: payload.isRunning,
        timestamp: new Date(),
      });
    },
    onOldMessagesReceived: (messages) => {
      const latestMessage = messages.sort((a, b) => {
        if (a.timestamp > b.timestamp) {
          return -1;
        }
        if (a.timestamp < b.timestamp) {
          return 1;
        }
        return 0;
      })[0];

      if (latestMessage) {
        setIsTimerRunningData({
          isRunning: latestMessage.payload.isRunning,
          timestamp: new Date(),
        });
      }
    },
  });


  usePubSub("RUNNING_TIME_DATA", {
    onMessageReceived: ({ message }) => {
      setRunningTimeData(message);
    },
    onOldMessagesReceived: (messages) => {
      const latestMessage = messages.sort((a, b) => {
        if (a.timestamp > b.timestamp) {
          return -1;
        }
        if (a.timestamp < b.timestamp) {
          return 1;
        }
        return 0;
      })[0];

      if (latestMessage) {
        setRunningTimeData(latestMessage.message);
      }
    },
  });

  usePubSub("TIMER_DATA", {
    onMessageReceived: ({ payload }) => {
      setTimerData(payload.time);
    },
    onOldMessagesReceived: (messages) => {
      const latestMessage = messages.sort((a, b) => {
        if (a.timestamp > b.timestamp) {
          return -1;
        }
        if (a.timestamp < b.timestamp) {
          return 1;
        }
        return 0;
      })[0];

      if (latestMessage) {
        setTimerData(latestMessage.payload.time);
      }
    },
  });


  usePubSub("VIDEO_RECORDING_ATTEMPT_ERR", {
    onMessageReceived: ({ payload }) => {
      setOpenVideoErr(payload.open);
      setAccuracy(payload.accuracy)
    },
    onOldMessagesReceived: (messages) => {
      const latestMessage = messages.sort((a, b) => {
        if (a.timestamp > b.timestamp) {
          return -1;
        }
        if (a.timestamp < b.timestamp) {
          return 1;
        }
        return 0;
      })[0];

      if (latestMessage) {
        setOpenVideoErr(latestMessage.payload.open);
      }
    },
  });

  usePubSub("TEXT_MATCHING_FAILED", {
    onMessageReceived: ({ payload }) => {
      setOpenTextMatchErr(payload.open);
    },
    onOldMessagesReceived: (messages) => {
      const latestMessage = messages.sort((a, b) => {
        if (a.timestamp > b.timestamp) {
          return -1;
        }
        if (a.timestamp < b.timestamp) {
          return 1;
        }
        return 0;
      })[0];

      if (latestMessage) {
        setOpenTextMatchErr(latestMessage.payload.open);
      }
    },
  })

  usePubSub("VIDEO_RECORDING_ATTEMPT_FAIL_ERR", {
    onMessageReceived: ({ payload }) => {
      setOpenVideoFailErr(payload.open);
    },
    onOldMessagesReceived: (messages) => {
      const latestMessage = messages.sort((a, b) => {
        if (a.timestamp > b.timestamp) {
          return -1;
        }
        if (a.timestamp < b.timestamp) {
          return 1;
        }
        return 0;
      })[0];

      if (latestMessage) {
        setOpenVideoFailErr(latestMessage.payload.open);
      }
    },
  });

  usePubSub("DEVICE_CHANGED", {
    onMessageReceived: ({ payload }) => {
      setOpenDeviceChange(payload.open);
    },
    onOldMessagesReceived: (messages) => {
      const latestMessage = messages.sort((a, b) => {
        if (a.timestamp > b.timestamp) {
          return -1;
        }
        if (a.timestamp < b.timestamp) {
          return 1;
        }
        return 0;
      })[0];

      if (latestMessage) {
        setOpenDeviceChange(latestMessage.payload.open);
      }
    },
  });

  usePubSub("ERROR_MEETING_LEFT", {
    onMessageReceived: ({ payload }) => {
      setOpenErrorBox(payload.open);
    },
    onOldMessagesReceived: (messages) => {
      const latestMessage = messages.sort((a, b) => {
        if (a.timestamp > b.timestamp) {
          return -1;
        }
        if (a.timestamp < b.timestamp) {
          return 1;
        }
        return 0;
      })[0];

      if (latestMessage) {
        setOpenErrorBox(latestMessage.payload.open);
      }
    },
  });

  usePubSub("JOURNEY_LIMIT", {
    onMessageReceived: ({ payload }) => {
      setOpenJourneyLimitBox(payload.showModal);
    },
    onOldMessagesReceived: (messages) => {
      const latestMessage = messages.sort((a, b) => {
        if (a.timestamp > b.timestamp) {
          return -1;
        }
        if (a.timestamp < b.timestamp) {
          return 1;
        }
        return 0;
      })[0];

      if (latestMessage) {
        setOpenJourneyLimitBox(latestMessage.payload.showModal);
      }
    },
  });



  usePubSub("ABORT_SIGNAL", {
    onMessageReceived: ({ payload }) => {
      setIsAbortSignal(payload.isAbort);
    },
    onOldMessagesReceived: (messages) => {
      const latestMessage = messages.sort((a, b) => {
        if (a.timestamp > b.timestamp) {
          return -1;
        }
        if (a.timestamp < b.timestamp) {
          return 1;
        }
        return 0;
      })[0];

      if (latestMessage) {
        setIsAbortSignal(latestMessage.payload.isAbort);
      }
    },
  });

  usePubSub("AUDIO_PRELOADED", {
    onMessageReceived: ({ message }) => {
    },
    onOldMessagesReceived: (messages) => {
    },
  });

  usePubSub("PRELOADED_AUDIO_SPOKEN", {
    onMessageReceived: ({ message }) => {
    },
    onOldMessagesReceived: (messages) => {
    },
  });

  usePubSub("END_JOURNEY_API_WAITING", {
    onMessageReceived: ({ payload }) => {
      setIsJourneyEnded(payload.isJourneyEnd);
    },
    onOldMessagesReceived: (messages) => {
      const latestMessage = messages.sort((a, b) => {
        if (a.timestamp > b.timestamp) {
          return -1;
        }
        if (a.timestamp < b.timestamp) {
          return 1;
        }
        return 0;
      })[0];

      if (latestMessage) {
        setIsJourneyEnded(latestMessage.payload.isJourneyEnd);
      }
    },
  });

  return <></>;
};

export default PubSubHandler;
